class FilterSearch {
  constructor(select, input, list, clear) {
    this.select = select
    this.input = input
    this.clear = clear
    this.list = list
  }

  init() {
    this.selectListener()
    this.inputListener()
    this.clearListener()
    this.onPageLoad()
  }

  selectListener() {
    if (this.select) {
      this.select.addEventListener('change', (ev) => {
        this.filter()
      })
    }
  }

  clearListener() {
    this.clear.addEventListener('click', () => {
      // Clear Query Params
      const url = new URL(window.location.href);
      url.searchParams.delete('topic');
      url.searchParams.delete('search');
      window.history.pushState(null, '', url.toString());
      // Clear inputs
      this.select.value = "all"
      this.input.value = ""
      // Show all items
      const items = this.list.querySelectorAll(".report")
      items.forEach(item => item.removeAttribute("style"))
      // Hide no-results
      this.list.parentElement.querySelector(".no-results").style.display = "none"
    })
  }

  onPageLoad() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(window.location.search);
    const topic = urlParams.get('topic');
    const search = urlParams.get('search')
    if (topic && this.select) {
      this.select.value = topic
      this.filter()
    }
    if (search) {
      this.input.value = search
      this.search()
    }
  }

  inputListener() {
    const debouncedTask = this.debounce(() => {
      this.search()
    }, 500);
    this.input.addEventListener('keydown', (ev) => {
      // Call the debounced task
      debouncedTask();
    })
  }

  search() {
    if (this.input.value.length > 0) {
      // Get all articles
      let items = null
      if (!this.select || this.select.value == "all") {
        items = this.list.querySelectorAll(".report")
      } else {
        items = this.list.querySelectorAll(`.report[data-topic="${this.select.value}"]`)
      }
      if (items) {
        items.forEach(item => {
          const title = item.querySelector(".report__title").innerText.toLowerCase()
          if (title.includes(this.input.value.toLowerCase())) {
            item.removeAttribute("style")
          } else {
            item.style.display = "none"
          }
          let description = item.querySelector('.report__description')
          if (description) {
            const descriptionText = description.innerText.toLowerCase()
            if (descriptionText.includes(this.input.value.toLowerCase())) {
              item.removeAttribute("style")
            }
          }
        })
      }
      const url = new URL(window.location.href);
      url.searchParams.set('search', this.input.value);
      window.history.pushState(null, '', url.toString());

      if (this.list.querySelectorAll('.report:not([style="display: none;"])').length == 0) {
        this.list.parentElement.querySelector(".no-results").removeAttribute("style")
      }
    } else {
      // Reset search
      this.input.value = ""
      const allItems = this.list.querySelectorAll('.report')
      allItems.forEach(item => {
        item.removeAttribute('style')
        if (this.select.value != "all" & this.select.value != item.getAttribute("data-topic")) {
          item.style.display = "none"
        }
      })
      const url = new URL(window.location.href);
      url.searchParams.delete('search');
      window.history.pushState(null, '', url.toString());
      // Hide no-results
      this.list.parentElement.querySelector(".no-results").style.display = "none"
    }
  }

  filter() {
    if (this.select.value == 'all') {
      // show all
      [...this.list.children].forEach(child => {
        child.removeAttribute("style")
      })
      const url = new URL(window.location.href);
      url.searchParams.delete('topic');
      window.history.pushState(null, '', url.toString());
      if (this.input.value.length > 0) {
        this.search()
      }
      return
    }

    [...this.list.children].forEach(child => {
      if (child.getAttribute("data-topic").includes(this.select.value)) {
        child.removeAttribute("style")
      } else {
        child.style.display = "none";
      }
    })

    const url = new URL(window.location.href);
    url.searchParams.set('topic', this.select.value);
    window.history.pushState(null, '', url.toString());

    if (this.input.value.length > 0) {
      this.search()
    }
  }

  debounce(func, delay) {
    let timerId;

    return function (...args) {
      clearTimeout(timerId);

      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
}

export default FilterSearch